const GroupCardIcon = ({
  width,
  height,
}: {
  width?: number
  height?: number
}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 312 312"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-labelledby="group-card-icon"
    >
      <title id="group-card-icon" />
      <path
        d="M304.149 215.136V213.699C304.149 179.511 280.484 150.815 248.657 143.167C248.708 143.167 248.76 143.115 248.862 143.064C249.478 142.756 250.094 142.448 250.71 142.14C263.39 135.364 272.014 121.966 272.014 106.566C272.014 84.2872 253.944 66.2178 231.666 66.2178C224.736 66.2178 218.268 67.9631 212.57 70.9918C199.993 77.8192 191.472 91.1659 191.472 106.463C191.472 122.685 201.02 136.647 214.828 143.064C214.726 143.064 214.674 143.064 214.572 143.115C214.572 143.115 214.572 143.115 214.623 143.115C208.104 144.655 201.995 147.119 196.297 150.302C196.143 150.353 196.04 150.456 195.886 150.507C195.886 150.507 195.886 150.507 195.835 150.507C174.018 162.982 159.285 186.544 159.285 213.494V214.931C159.285 220.783 164.008 225.506 169.86 225.506H272.271C272.271 225.506 272.271 225.557 272.219 225.608H293.625C299.477 225.608 304.2 220.886 304.2 215.034L304.149 215.136Z"
        fill="#FFBC0D"
        stroke="black"
        strokeWidth="7.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.663 215.136V213.699C152.663 179.511 128.999 150.815 97.1717 143.167C97.223 143.167 97.2744 143.115 97.377 143.064C97.993 142.756 98.6091 142.448 99.2251 142.14C111.904 135.364 120.528 121.966 120.528 106.566C120.528 84.2872 102.459 66.2178 80.1803 66.2178C73.2503 66.2178 66.7822 67.9631 61.0842 70.9918C48.5075 77.8192 39.9861 91.1659 39.9861 106.463C39.9861 122.685 49.5342 136.647 63.3429 143.064C63.2402 143.064 63.1889 143.064 63.0862 143.115C63.0862 143.115 63.0862 143.115 63.1376 143.115C56.6182 144.655 50.5095 147.119 44.8115 150.302C44.6575 150.353 44.5548 150.456 44.4008 150.507C44.4008 150.507 44.4008 150.507 44.3495 150.507C22.5327 162.982 7.79999 186.544 7.79999 213.494V214.931C7.79999 220.783 12.5227 225.506 18.3747 225.506H120.785C120.785 225.506 120.785 225.557 120.734 225.608H142.14C147.992 225.608 152.715 220.886 152.715 215.034L152.663 215.136Z"
        fill="#FFBC0D"
        stroke="black"
        strokeWidth="7.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M236.748 234.078V232.486C236.748 194.345 210.363 162.416 174.84 153.843C174.891 153.843 174.994 153.792 175.045 153.741C175.764 153.433 176.431 153.073 177.098 152.714C191.266 145.117 200.866 130.23 200.866 113.033C200.866 88.1877 180.743 68.0649 155.898 68.0649C148.198 68.0649 140.96 70.0156 134.594 73.4036C120.58 81.0523 111.083 95.8877 111.083 112.93C111.083 131 121.709 146.554 137.11 153.741C137.007 153.741 136.904 153.741 136.853 153.792C136.853 153.792 136.904 153.792 136.956 153.792C129.717 155.537 122.839 158.258 116.525 161.8C116.371 161.903 116.217 161.954 116.114 162.057C116.114 162.057 116.063 162.057 116.011 162.057C91.6793 175.968 75.2526 202.2 75.2526 232.281V233.872C75.2526 240.392 80.5399 245.679 87.0593 245.679H201.225C201.225 245.679 201.225 245.782 201.174 245.782H225.044C231.563 245.782 236.851 240.494 236.851 233.975L236.748 234.078Z"
        fill="#DB0007"
        stroke="black"
        strokeWidth="7.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M168.679 179.767C173.71 179.767 177.765 200.917 177.765 226.994H185.055C185.055 198.915 177.714 176.123 168.731 176.123C163.597 176.123 159.029 182.95 156 193.679C153.023 183.001 148.403 176.123 143.269 176.123C134.235 176.123 126.945 198.915 126.945 226.994H134.235C134.235 200.917 138.29 179.767 143.321 179.767C148.351 179.767 152.407 199.274 152.407 223.349H159.645C159.645 199.274 163.7 179.767 168.731 179.767"
        fill="#FFBC0D"
      />
    </svg>
  )
}

export default GroupCardIcon
